import size from 'lodash/size';
import {capitalize, endsWith, trim} from 'lodash/string';

export function escapeHtml(text) {
  const textStr = text ? text.toString() : ''; //force conversion to String
  return textStr
      .replace(/<br\/?>/gi, ' ')
      // Strip everything...
      .replace(/<\/?[A-z]+ *[ -=/:.A-z"']*?>/gi, '');
}

export function shouldTruncateString(text, limit) {
  return size(text) > limit;
}

export function truncateString(text, limit) {
  return (shouldTruncateString(text, limit)) ? `${trim(text.substring(0, limit - 3))}...` : text;
}

export function titleCase(str) {
  return str && str.split(' ').map(w => capitalize(w)).join(' ');
}

export const addNewLine = (text) => {
  return endsWith(text, '\n') ? text : text + '\n';
};

export const filenameFromUrl = (url) => {
  return url.split('#').shift().split('?').shift().split('/').pop();
};

export function jsonifyValue(value) {
  if (!value || (Array.isArray(value) && !value.length)) {
    return null;
  } else {
    return JSON.stringify(value);
  }
}
